'use client';

import { useTina } from 'tinacms/dist/react';
import { ArticleQuery } from '../../app/pageClient';
import { ArticleListServer } from './ArticleList';
export interface ArticleListClientProps {
  articleQuery: ArticleQuery;
}
export default function ArticleListClient({
  articleQuery,
  ...props
}: ArticleListClientProps) {
  const clientData = useTina({
    query: articleQuery.query,
    variables: articleQuery.variables,
    data: articleQuery.data
  });
  return <ArticleListServer articleData={clientData.data} {...props} />;
}